export class StandardBackupPolicyPlan {
    'backupSchedules';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupSchedules",
            "baseName": "backupSchedules",
            "type": "Array<StandardBackupSchedules>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StandardBackupPolicyPlan.attributeTypeMap;
    }
    constructor() {
    }
}
